import { SimpleClient } from "./Client";
import { Image } from "./Image";
import { WorkRegion } from "./WorkRegion";
import { SimpleEvent, IdentityRole, AccreditationLevel } from "./Event";
import { AttachmentLog } from "./File";

export enum AccessLevel {
    IDENTITY_MANAGER = "IDENTITY_MANAGER",
    SCHEDULE_MANAGER = "SCHEDULE_MANAGER",
    SCHEDULE_ADMIN = "SCHEDULE_ADMIN",
    SCHEDULE_AND_PUNCH_CLOCK_ADMIN = "SCHEDULE_AND_PUNCH_CLOCK_ADMIN"
}

export interface TermsAcknowledgement {
    id: number;
    eventId: number | null;
    eventName: string | null;
    dateAcknowledged: Date;
    termsVersion: string | null;
    submittedFirstName: string;
    submittedLastName: string;
    submittedEmail: string;
    submittedCompanyName: string;
}

export interface EventProvisioning {
    dateCreated: Date;
    provisionedFor: SimpleEvent;
    accreditationLevel: AccreditationLevel;
    secondaryRoleName: string;
    role: IdentityRole;
}

export interface AccessLevelProvisioning {
    dateCreated: Date;
    client: SimpleClient;
    accessLevel: AccessLevel;
    allowedEvents?: SimpleEvent[];
}

export interface ExternalAccessProvisioning {
    id: number;
    dateCreated: Date;
    targetSystem: string;
    operation: string;
    parameters: Map<string, string>;
    client: SimpleClient;
}

export enum AppleIdBehaviour {
    NONE = "NONE",
    OPTIONAL = "OPTIONAL",
    REQUIRED = "REQUIRED"
}

export interface IdentityVaccineInformation {
    vaccinationDate: Date;
}

export interface SimpleIdentity {
    id: number;
    uuid: string;
    dateArchived?: Date;

    firstName: string;
    middleName: string;
    lastName: string;

    companyName: string;

    homePhoneNumber: string;
    mobilePhoneNumber: string;
    email: string;

    parentCustomer?: SimpleClient;
    regions: Array<WorkRegion>;

    printableNotes: string;

    employeeNumber: string;
    payRate: string;
    pending?: boolean;
}

export interface Identity extends SimpleIdentity {
    dateCreated: Date;
    lastModified?: Date;

    city: string;
    province: string;
    country: string;
    streetAddress: string;
    postalCode: string;

    // Admin only
    SIN?: string;
    dateOfBirth?: Date;
    privateNotes?: string;
    admin?: boolean;
    ableToLogin?: boolean;
    clientBadgeRoleName?: string;

    pin: string;

    kioskAccess: boolean;
    configAccess: boolean;
    /** POS config sections granted individually (e.g. "MAINTENANCE"); see POS_CONFIG_SECTIONS. */
    configSections?: string[];

    createdBy?: SimpleIdentity;
    picture?: Image;

    eventProvisionings: Array<EventProvisioning>;
    termsAcknowledgements?: Array<TermsAcknowledgement>;
    accessLevelProvisionings: Array<AccessLevelProvisioning>;
    externalAccess: Array<ExternalAccessProvisioning>;

    attachments: AttachmentLog;

    appleIdBehaviour: AppleIdBehaviour;

    vaccineInfo?: IdentityVaccineInformation | null;
}

export interface QuickProvisioningIdentity extends SimpleIdentity {
    roleId: number;
    accreditationLevelId: number | null;
    secondaryRoleName: string;
    termsAcknowledged?: boolean;
}
